module.exports = __webpack_public_path__ + "static/media/edtech-impact.d9103a04.png";